import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "./ChangeLanguage.constants";
import eng from "../images/english.svg";
import ozbek from "../images/ozbek.svg";
import rus from "../images/rus.svg";
import vector from "../images/vector.svg";
import "./changeLanguage.css";

const ChangeLanguage = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLang = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const selectedLang = event.target.getAttribute("data-language");
    i18n.changeLanguage(selectedLang);
    setAnchorEl(null);
    // window.location.reload();
  };

  return (
    <div className="menu_lang_box">
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="default_btn_lang"
      >
        <img
          src={
            localStorage.getItem("i18nextLng") === "ru"
              ? rus
              : localStorage.getItem("i18nextLng") === "eng"
              ? eng
              : ozbek
          }
          alt="vector"
        />
        {localStorage.getItem("i18nextLng") === "ru"
          ? "РУС"
          : localStorage.getItem("i18nextLng") === "eng"
          ? "ENG"
          : "UZB"}
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: "top",
          horizontal: -4,
        }}
        className="menu_langs_content"
      >
        <MenuItem
          onClick={handleSelectLang}
          data-language={LANGUAGES.uz}
          className="lang_menuItem"
        >
          <img
            src={ozbek}
            alt="uzb"
            className="lang_img"
            data-language={LANGUAGES.uz}
          />
          UZB
        </MenuItem>
        <MenuItem onClick={handleSelectLang} data-language={LANGUAGES.ru}>
          <img
            src={rus}
            alt="rus"
            className="lang_img"
            data-language={LANGUAGES.ru}
          />{" "}
          RUS
        </MenuItem>
        <MenuItem onClick={handleSelectLang} data-language={LANGUAGES.en}>
          <img
            src={eng}
            alt="eng"
            className="lang_img"
            data-language={LANGUAGES.en}
          />
          ENG
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ChangeLanguage;
